const ClockImage = () => {
  return (
    <svg
      width="51"
      height="52"
      viewBox="0 0 51 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.7675 49C38.7596 49 48.4811 39.216 48.4811 27.1468C48.4811 15.0775 38.7596 5.29352 26.7675 5.29352C14.7754 5.29352 5.05386 15.0775 5.05386 27.1468C5.05386 39.216 14.7754 49 26.7675 49Z"
        fill="#C76D00"
      />
      <path
        d="M45.586 30.9356C48.2435 19.6037 41.2702 8.24922 30.0107 5.57465C18.7512 2.90008 7.46927 9.91822 4.81179 21.2501C2.15431 32.582 9.12761 43.9365 20.3871 46.611C31.6466 49.2856 42.9285 42.2675 45.586 30.9356Z"
        fill="white"
        stroke="#F78A05"
        strokeWidth="2.38"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.2482 14.0605C36.0295 11.2986 31.851 9.6311 27.2893 9.6311C17.1003 9.6311 8.84188 17.9427 8.84188 28.1972C8.84188 32.7955 10.4987 36.9972 13.2503 40.2403C9.2725 36.832 6.7508 31.7598 6.7508 26.0927C6.7508 15.8382 15.0093 7.52658 25.1982 7.52658C30.8292 7.52658 35.8689 10.0608 39.2482 14.0605Z"
        fill="#DAD2D2"
      />
      <path
        d="M37.6926 6.81545L35.5246 5.58965C34.8503 5.20797 34.6155 4.35407 35.0051 3.69346C35.3948 3.03285 36.2665 2.80286 36.9408 3.18455L39.1088 4.41035C39.7832 4.79203 40.018 5.64593 39.6283 6.30654C39.2387 6.96715 38.367 7.19714 37.6926 6.81545Z"
        fill="#191919"
      />
      <path
        d="M45.9878 15.3693L44.9899 13.2599C44.6795 12.6018 44.7977 11.6983 45.2536 11.2501C45.7094 10.8019 46.3352 10.9726 46.6457 11.6307L47.6435 13.7401C47.954 14.3982 47.8357 15.3017 47.3799 15.7499C46.9241 16.1981 46.2982 16.0274 45.9878 15.3693Z"
        fill="#191919"
      />
      <path
        d="M8.5941 21.4485L11.7019 22.2812"
        stroke="#7F7F7F"
        strokeWidth="1.43"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M21.7608 44.0861L22.5882 40.9982"
        stroke="#7F7F7F"
        strokeWidth="1.43"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M10.4732 35.4662L13.2539 33.8727"
        stroke="#7F7F7F"
        strokeWidth="1.43"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.663 15.1605L14.2368 17.078"
        stroke="#7F7F7F"
        strokeWidth="1.43"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.4244 41.013L17.3479 38.4606"
        stroke="#7F7F7F"
        strokeWidth="1.43"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M28.7344 41.3756L29.1944 44.5402"
        stroke="#7F7F7F"
        strokeWidth="1.43"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.1603 28.8431L11.3411 28.3957"
        stroke="#7F7F7F"
        strokeWidth="1.43"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M9.89433 18.015L12.7748 19.4405"
        stroke="#7F7F7F"
        strokeWidth="1.43"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M18.3005 42.7811L19.7246 39.9211"
        stroke="#7F7F7F"
        strokeWidth="1.43"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.94651 32.1102L11.9899 31.0971"
        stroke="#7F7F7F"
        strokeWidth="1.43"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M14.1597 12.4557L16.3023 14.847"
        stroke="#7F7F7F"
        strokeWidth="1.43"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12.6964 38.5215L15.0933 36.4019"
        stroke="#7F7F7F"
        strokeWidth="1.43"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M25.6824 41.4985L25.5044 44.6886"
        stroke="#7F7F7F"
        strokeWidth="1.43"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M7.99919 25.173L11.2077 25.3602"
        stroke="#7F7F7F"
        strokeWidth="1.43"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19.9651 15.7463L25.4464 26.0927L41.7663 10.7917"
        stroke="#191919"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ClockImage;
